import { defineStyle } from "@chakra-ui/react";

export const MobileTaskCardStyles = () => {
  return {
    mainContainer: defineStyle({
      width: "480px",
      borderRadius: "lg",
      boxShadow: "md",
      p: 4,
      bg: "white",
      _hover: {
        cursor: "pointer",
      },
      "@media screen and (min-width: 1280px) and (max-width: 1360px)": {
        width: "360px",
      },
      "@media screen and (min-width: 1360px) and (max-width: 1536px)": {
        width: "430px",
      },
    }),
    topContainer: defineStyle({
      align: "stretch",
      width: "100%",
      h: "72%",
    }),
    subjectIcon: defineStyle({
      width: "16px",
      height: "16px",
    }),
    gpIcon: defineStyle({
      width: "16px",
      height: "16px",
      mr: "8px",
    }),
    detailsContainer: defineStyle({
      width: "100%",
      alignItems: "start",
    }),
    topLine: defineStyle({
      width: "100%",
    }),
    taskTypeText: defineStyle({
      fontSize: "12px",
      fontWeight: 400,
      bg: "#FEFAE6",
      borderRadius: "14px",
      padding: "6px",
      lineHeight: "16px",
      fontFamily: "Poppins",
    }),
    completionContainer: defineStyle({
      spacing: 2,
    }),
    completionText: defineStyle({
      fontSize: "12px",
      lineHeight: "16px",
      color: "#786AC5",
    }),
    overDueDate: defineStyle({
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "600",
      color: "red",
    }),
    inTimeDate: defineStyle({
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "600",
      color: "#130159D9",
    }),
    tickMarkIcon: defineStyle({
      width: "24px",
      height: "24px",
    }),
    taskTitle: defineStyle({
      noOfLines: 2,
      fontSize: "16px",
      lineHeight: "24px",
      fontFamily: "Poppins",
      fontWeight: "500",
      mb: 4,
      color: "#130159D9",
    }),
    bottomContainer: defineStyle({
      bg: "#FEFAE6",
      padding: 2,
      // mb: 2,
      borderRadius: "4px",
    }),
    bottomText: defineStyle({
      color: "#6D6BAE",
    }),
  };
};
